import React from 'react'
import './style.css'
import { ArrowLeft, Bell, Plus } from '@phosphor-icons/react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../utils/context'

export default function Header() {
  const location = useLocation()
  const navigation = useNavigate()
  const { user } = useAuth()

  if (location.pathname === '/' || location.pathname === '/games') {
    return (
      <div className='Header'>
        <div className={location?.pathname === '/project' ? 'Header_Left_Icon Header_Left_Icon_Show' : 'Header_Left_Icon'} onClick={() => navigation(-1)}>
          <ArrowLeft size={20} />
        </div>
        <h2>{location?.pathname === '/project' ? "Untitled Project" : `Hi, ${user?.name}`}</h2>
        <div className='FlexCon' />
        <Bell className='Header_Icon' size={19} />
        <button>Create <Plus weight='regular'/></button>
      </div>
    )
  } else {
    return null
  }
}
